import { eventBus } from '../eventBus.js';
import { array } from '../../node_modules/@lfi/jsonstat-js/dist/array.js';
import { svg } from '../utils/svg.js';

/**
 * Creates the map header.
 * The map header is a copy of the result table header.
 * @module gui/header
 */
export const header = {

  /**
   * @type {JsonStatReader} NAFIDAS JSON-stat
   */
  _reader: null,

  /**
   * ID of the header div
   * @type String
   * @private
   */
  _cssClass: 'result-table__header',

  /**
   * @type {HTMLDivElement}
   */
  domNode: null,

  /**
   * Renders the header.
   * The header is parsed from the html of the full result table.
   * @param {JsonStatReader} jsonStatReader
   * @param {Number} rowIdx
   * @param {String} tableHTML html to parse
   * @returns {void}
   */
  render (jsonStatReader, rowIdx, tableHTML) {
    this._reader = jsonStatReader;
    this.domNode = this._renderHeader(tableHTML, rowIdx);
    this._initEvents();
  },

  /**
   * Insert the table header into the map header.
   * @private
   * @param {String} tableHTML html to parse
   * @param {Number} rowIdx
   */
  _renderHeader (tableHTML, rowIdx) {
    const header = document.querySelector('.' + this._cssClass);
    const dom = new DOMParser();
    const html = dom.parseFromString(tableHTML, 'text/html');
    header.innerHTML = html.querySelector('table caption').innerHTML;
    this._insertClassificationItem(rowIdx);
    return header;
  },

  /**
   * Insert the selected classification item into the header as html.
   * @private
   */
  _insertClassificationItem (rowIdx) {
    const parentDiv = document.querySelector('.' + this._cssClass);
    const elementBefore = document.querySelector('.headerPeriod');

    const dimensions = this._reader.getDimIdOthers();
    const fromTo = array.rowToLinear(rowIdx, this._reader.getDimSizes());
    dimensions.forEach((dimId, idx) => {
      const div = document.createElement('div');
      div.classList.add('headerSelectedRow');

      const spanLabel = document.createElement('span');
      spanLabel.classList.add('headerLabel');
      spanLabel.innerText = this._reader.getLabel(dimId) + ': ';
      div.append(spanLabel);

      const catId = this._reader.getCategoryIdByOffset(fromTo[0], idx);
      const spanText = document.createElement('span');
      spanText.id = 'item-label-' + idx;
      spanText.innerText = this._reader.getCategoryLabel(dimId, catId);
      div.append(spanText);

      parentDiv.insertBefore(div, elementBefore);
    });
  },

  /**
   * Initialize the event listeners on the event-bus
   * @listens eventBus~event:rowSelect
   * @returns {void}
   * @private
   */
  _initEvents () {
    eventBus.add('rowSelect', this._updateClassificationItem.bind(this));
  },

  /**
   * Update the classification of the header.
   * @param {RowSelectEvent} evt
   * @returns {void}
   * @private
   */
  _updateClassificationItem (evt) {
    const dimensions = this._reader.getDimIdOthers();
    const fromTo = array.rowToLinear(evt.detail.rowIdx, this._reader.getDimSizes());
    dimensions.forEach((dimId, idx) => {
      const element = document.getElementById('item-label-' + idx);
      const catId = this._reader.getCategoryIdByOffset(fromTo[0], idx);
      element.innerText = this._reader.getCategoryLabel(dimId, catId);
    });
  },

  /**
   * Converts and returns the table header as SVG wrapped in a group element;
   * Assumes that the domNode contains HTMLDivElements as children to parse.
   * @return {SVGGElement}
   */
  exportSvg: function () {
    let textNode, text, y = 0, g, i, len, nl;

    g = svg.create('g', {
      id: 'header'
    });

    // loop through div's in header and add them as <text>
    nl = this.domNode.getElementsByTagName('div');
    for (i = 0, len = nl.length; i < len; i++) {
      text = nl[i].innerHTML;
      textNode = this.createSVGTextNode(text);
      y += 16;
      textNode.setAttribute('y', y);
      g.appendChild(textNode);
    }

    return g;
  },

  /**
   * Creates an SVG text node.
   * Strips tags from the string and prevents double encoding text.
   * @param {string} str
   * @return {SVGTextElement}
   */
  createSVGTextNode: function(str) {
    let text, textNode;
    text = str;
    text = text.replace(/span/g, 'tspan');
    textNode = svg.create('text');
    textNode.innerHTML = text;

    return textNode;
  },
};